export class ListFindingExclusionPatternsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "paths",
            "baseName": "paths",
            "type": "Array<FindingExclusionPattern>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListFindingExclusionPatternsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
